import React from 'react';
import { ListGroupItem } from 'reactstrap';
import { BiChevronDown, BiChevronRight } from 'react-icons/bi';
import S from '../ArborescenceProjets.module.scss';
import Bouton from '../../../../UI/Bouton/Bouton';
import { AiOutlineTable, VscGraph } from 'react-icons/all';
import GrapheTauxDePannesConteneur from './GrapheTauxDePannesConteneur/GrapheTauxDePannesConteneur';

const DEFAULT_PADDING = 16;
const ICON_SIZE = 0;
const LEVEL_SPACE = 16;

// Define proper interface for props
interface ListItemProps {
  level?: number;
  hasNodes?: boolean;
  isOpen?: boolean;
  label?: string;
  searchTerm?: string;
  openNodes?: any;
  toggleNode?: () => void;
  matchSearch?: boolean;
  focused?: boolean;
  project_id: string | number;
  parent_id?: string | number;
  project_name?: string;
  project_fails?: number;
  sen_total?: number;
  ratio_fails?: number;
  start_interval?: any;
  end_interval?: any;
  criticity_id_list?: any;
  types_id_list?: any;
  handleDisplayGraph?: (id: string | number) => any;
  handleProjetCapteurDefaillant?: (id: number) => void;
}

// Method 1: Use React.FC with explicit return type
const ListItem: React.FC<ListItemProps> = ({
  level = 0,
  hasNodes,
  isOpen,
  label,
  searchTerm,
  openNodes,
  toggleNode,
  matchSearch,
  focused,
  project_id,
  parent_id,
  project_name,
  project_fails,
  sen_total,
  ratio_fails,
  ...props
}) => {
  return (
    <ListGroupItem
      key={project_id}
      style={{
        paddingLeft: DEFAULT_PADDING + ICON_SIZE + level * LEVEL_SPACE,
        paddingTop: '0px',
        paddingBottom: '0px',
        cursor: 'pointer',
        backgroundColor: '#3C3935',
        boxShadow: focused ? '0px 0px 5px 0px #222' : 'none',
        zIndex: focused ? 999 : 'unset',
        position: 'relative',
        textAlign: 'center',
      }}
    >
      <div className={S.Noeud}>
        <div
          onClick={(e) => {
            hasNodes && toggleNode && toggleNode();
            e.stopPropagation();
          }}
        >
          {hasNodes ? ( //affichage d'icône dossier et flèche déroulante si le noeud à des enfants sinon flèche simple
            <span
              onClick={(e) => {
                hasNodes && toggleNode && toggleNode();
                e.stopPropagation();
              }}
            >
              {isOpen ? ( //affichage de l'icône d'ouverture/fermeture
                <span>
                  {/*icône d'ouvert*/}
                  {/* <FaCaretDown size={20} className={S.icon}/> */}
                  <BiChevronDown size={15} className={S.arrow} />
                </span>
              ) : (
                <span className={S.newstile}>
                  {/*icône fermer*/}
                  {/* <FaCaretRight size={20} className={S.icon}/> */}
                  <BiChevronRight size={15} className={S.arrow} />
                </span>
              )}
            </span>
          ) : null}
          {/*affichage du lien de redirection pour modifier l'url et enregistre la modification dans redux*/}
          <span>{label}</span>
        </div>

        <div>
          <Bouton ajoutClass={S.bouton} cliquer={() => {}}>
            {/* <AiOutlineStar size={14} color={'#eeb214'}/> */}
            {'Id projet: ' + project_id + ' | '}
            {'Nombre de pannes: ' + project_fails + ' | '}
            {'Nombre de capteurs: ' + sen_total + ' | '}
            {'Ratio de panne: ' + ratio_fails + '%'}
          </Bouton>
          <GrapheTauxDePannesConteneur
            start_interval={props.start_interval}
            end_interval={props.end_interval}
            criticity_id_list={props.criticity_id_list}
            types_id_list={props.types_id_list}
            texte_ouverture={''}
            icone={<VscGraph size={14} className={S.icon} />}
            projects_id={props.handleDisplayGraph?.(project_id)}
            project_id={project_id}
          />
          <Bouton
            ajoutClass={S.bouton}
            cliquer={() =>
              props.handleProjetCapteurDefaillant?.(
                parseInt(project_id.toString())
              )
            }
          >
            <AiOutlineTable size={14} className={S.icon} />
          </Bouton>
        </div>
      </div>
    </ListGroupItem>
  );
};
export default ListItem;
